// services/statisticsService.js
// Все запросы к API, связанные со страницей статистики

import api from './api';

/**
 * Получить статистику по камере за период.
 * @param {number} cameraId
 * @param {string} startDate  — ISO datetime string
 * @param {string} endDate    — ISO datetime string
 * @param {string[]} shifts   — ['SHIFT_1', 'SHIFT_2', 'SHIFT_3'] или пустой массив (= все смены)
 * @returns {Promise<CameraStatisticsResponse>}
 */
export const getCameraStatistics = (cameraId, startDate, endDate, shifts = []) =>
  api
    .get(`/cameras/${cameraId}/statistics`, {
      // API принимает shifts как повторяющийся query-параметр; массив в
      // shifts=SHIFT_1&shifts=SHIFT_2 раскладывает общий paramsSerializer из api.js.
      params: {
        start_date: startDate,
        end_date: endDate,
        ...(shifts.length > 0 ? { shifts } : {}),
      },
    })
    .then((r) => r.data);

/**
 * Обновить fte_const камеры.
 * Параметр owner обязателен для PATCH — передаём его из ранее загруженного объекта камеры.
 * @param {number} cameraId
 * @param {string} owner        — обязательное поле (из CameraResponse)
 * @param {number|null} fteConst
 * @returns {Promise<CameraResponse>}
 */
export const updateCameraFteConst = (cameraId, owner, fteConst) =>
  api
    .patch(`/cameras/${cameraId}`, { owner, fte_const: fteConst })
    .then((r) => r.data);

/**
 * GANTT02 (ТЗ v4 §19.2, FE-FIX16): диаграмма Ганта v2 поверх observation_ledger.
 *
 * Контракт: camera_id в пути, обязательные metric/from/to, опциональные
 * zone_id, mode (raw|compressed), bucket_seconds, max_points. Ответ несёт свой
 * display_timezone (timezone_basis = camera_display_timezone) и абсолютный
 * интервал (synchronization_basis = absolute_utc_interval), поэтому подписи
 * панели берутся из ответа, а не из локальной зоны браузера.
 *
 * `config` пробрасывается в axios целиком ради `signal`: смена фильтров должна
 * отменять всю прежнюю группу запросов, а не просто игнорировать её ответы.
 */
export const getCameraGanttV2 = (cameraId, params, config = {}) =>
  api
    .get(`/cameras/${cameraId}/statistics/gantt-v2`, { params, ...config })
    .then((r) => r.data);

/**
 * ТЗ V5 №16: многодорожечный Гант кадров и интервалов событий камеры.
 * Фильтры кадров — те же, что у /cameras/{id}/frames; metrics, event_types и
 * rule_ids — повторяющиеся параметры (их раскладывает paramsSerializer).
 * Страница не больше 1000 кадров, дальше has_more/next_offset.
 */
export const getFrameGanttV3 = (cameraId, params, config = {}) =>
  api
    .get(`/cameras/${cameraId}/statistics/frame-gantt-v3`, { params, ...config })
    .then((r) => r.data);
